import React from "react";
import { Container, Row, Col, Form, FormControl, Button, Card } from "react-bootstrap";

const ContainerCheckDocsBDS3 = ({
  showTitle,
  subtitle,
  lastcheck,
  startDate,
  handleOnChangeFilter,
  busqueda,
}) => {
  return (
    <Container fluid className="page-container">
      <div className="page-header">
        <div>
          <h2 className="page-title">{showTitle}</h2>
          <p className="page-subtitle">
            {subtitle}
            {lastcheck ? ` · Última actualización: ${lastcheck}` : ''}
          </p>
        </div>
      </div>

      <Card className="data-card">
        <Card.Body>
          <Form onSubmit={busqueda} className="filter-form">
            <Row>
              <Col xs={12} md={6} lg={4}>
                <Form.Group className="form-field">
                  <Form.Label>Fecha comparación</Form.Label>
                  <FormControl
                    type="date"
                    value={startDate}
                    onChange={handleOnChangeFilter}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6} lg={3} className="d-flex align-items-end form-actions">
                <Button type="submit" className="btn-primary-action">
                  <i className="nc-icon nc-zoom-split" />
                  Buscar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ContainerCheckDocsBDS3;
